'use client';

import { MantineProvider } from '@mantine/core';
import type { ReactNode } from 'react';

import { mantineProviderProps } from './theme';

/**
 * Shared Mantine provider for every rendering root (App Router, Pages
 * Router, Storybook).
 *
 * This must stay a client component: `mantineProviderProps` comes from a
 * `'use client'` module, and spreading such an object inside a Server
 * Component silently drops every prop (client-reference proxies have no
 * enumerable keys on the server), leaving Mantine on its default theme.
 */
export function BlinqMantineProvider({ children }: { children: ReactNode }) {
  return <MantineProvider {...mantineProviderProps}>{children}</MantineProvider>;
}
